module.exports = __webpack_public_path__ + "static/media/right_forearm_flexed.f83669a5.png";